import { BrowserRouter } from "react-router-dom";
import Routes from "routes/routes";
import { AuthContextProvider } from "contexts/AuthContextProvider";
import { ClientContextProvider, client } from "utils/ApiUtils";
import { MyContextProvider } from "contexts/Context";
import React, { useEffect, useState } from "react";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import Brightness3Icon from "@mui/icons-material/Brightness2";
import Tooltip from "@mui/material/Tooltip";
import Animation from "assets/Lotties/nonetwork.json";
import { Player } from "@lottiefiles/react-lottie-player";
import { Fab, IconButton } from "@mui/material";
const App = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const toggleTheme = () => {
    if (theme === "light") {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  };

  useEffect(() => {
    localStorage?.setItem("theme", theme);
    document.body.className = theme;
    // intervalId();
  }, [theme]);

  // online ofline status
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    function onlineHandler() {
      setIsOnline(true);
    }

    function offlineHandler() {
      setIsOnline(false);
    }

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);

  return (
    <>
      {isOnline ? (
        <BrowserRouter>
          <ClientContextProvider client={client}>
            <AuthContextProvider>
              <MyContextProvider>
                {" "}
                <Fab
                  // color="primary"
                  className="dark-light toggleBtn"
                  onClick={toggleTheme}
                >
                  <Tooltip title="" className="moon">
                    <IconButton>
                      <Brightness3Icon aria-label="Dark mode" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="" className="sun">
                    <IconButton>
                      <WbSunnyIcon aria-label="Light mode" />
                    </IconButton>
                  </Tooltip>
                </Fab>
                <Routes />
              </MyContextProvider>
            </AuthContextProvider>
          </ClientContextProvider>
        </BrowserRouter>
      ) : (
        <div className="interNetnotava">
          <Player src={Animation} className="noNetwork" loop autoplay />
          {/* <svg
            className="MuiSvgIcon-root"
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7l2-2zm-4 4c-1.29-1.29-2.84-2.13-4.49-2.56l3.53 3.53.96-.97zM2 3.05L5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24C7.81 10.89 6.27 11.73 5 13v.01L6.99 15c1.36-1.36 3.14-2.04 4.92-2.06L18.98 20l1.27-1.26L3.29 1.79 2 3.05zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0z"></path>
          </svg> */}
          <div id="headingone">Your Connection is Offline.</div>
          Please check your Wifi Connection.
        </div>
      )}
    </>
  );
};

export default App;
